import React from 'react'

import { Columns } from '@/components/layout'
import { Link } from '@/components/common'

import styles from './BlogNav.module.scss'

const categories = [
  {
    messageId: 'pages.blog.navigation.accounting',
    uri: '/blog/category/accounting-bookkeeping/',
  },
  {
    messageId: 'pages.blog.navigation.taxTime',
    uri: '/blog/category/small-business-taxes/',
  },
  {
    messageId: 'pages.blog.navigation.smallBusiness',
    uri: '/blog/category/small-business-resources/',
  },
  {
    messageId: 'pages.blog.navigation.contractor',
    uri: '/blog/category/contractor-resources/',
  },
  {
    messageId: 'pages.blog.navigation.homeFinance',
    uri: '/blog/category/home-finance/',
  },
  {
    messageId: 'pages.blog.navigation.news',
    uri: '/blog/category/neat-news/',
  },
]

const BlogNav = () => (
  <Columns center className={styles.wrapper}>
    {categories.map(category => (<Link key={category.messageId} messageId={category.messageId} to={category.uri} />))}
  </Columns>
)

export default BlogNav
